import $http from '@/config/requestConfig';
import store from '@/store';
import base from "@/config/baseUrl";

//个人信息
function getMyInfo(callback){
	let httpData = {}
	$http.post("/api/user/info",httpData).then(res => {
		// 储存登录信息
		store.commit('setUserInfo',res)
		callback && callback(res)
	})
}

//排队信息
function getBalance(){
	let httpData = {}
	$http.post("/api/video/info",httpData,{load:false,isPrompt: false}).then(res => {
		store.commit('setBalanceInfo',res)
	})
}

//客服
function getKefu(){
	let httpData = {}
	$http.post("/api/index/kefucode",httpData,{load:false}).then(res => {
		store.commit('setKefucode',res)
	})
}

//群二维码
function getQewm(){
	let httpData = {}
	$http.post("/api/index/groupcode",httpData,{load:false}).then(res => {
		store.commit('setQewm',res)
	})
}

export {
	getMyInfo,
	getBalance,
	getKefu,
	getQewm
}